import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {},
    inner: {
      display: 'flex',
      flexDirection: 'column',
      gap: 48,
    },
    listing: {
      display: 'flex',
      flexDirection: 'column',
      gap: 32,
      [theme.fn.largerThan('sm')]: {
        gap: 48,
      },
    },
    group: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
    },
    desc: {
      fontSize: 16,
      lineHeight: rem(24),
      [theme.fn.largerThan('sm')]: {
        fontSize: 18,
        lineHeight: rem(28),
      },
    },
    heading: {
      fontSize: 28,
      lineHeight: rem(34),
      fontWeight: 500,
      [theme.fn.largerThan('sm')]: {
        fontSize: 48,
        lineHeight: rem(58),
      },
    },
    item: {
      height: '100%',
    },
  }
})
